import { useEffect, useState } from 'react';

import type { PluginListenerHandle } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';

import { getIsOnline } from '../helpers/utils.helper';

export const useCheckOnline = () => {
  const [online, setOnline] = useState(true);

  useEffect(() => {
    const checkOnline = async () => {
      const online = await getIsOnline();
      setOnline(online);
    };

    // FIXME
    // oxlint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
    checkOnline();
  }, []);

  // listeners
  useEffect(() => {
    let appListener: PluginListenerHandle;
    const onlineEventHandler = () => {
      setOnline(true);
    };
    const offlineEventHandler = () => {
      setOnline(false);
    };

    if (Capacitor.isPluginAvailable('Network')) {
      (async () => {
        const { Network } = await import('@capacitor/network');
        appListener = await Network.addListener('networkStatusChange', (status) => {
          setOnline(status.connected);
        });
      })();
    } else {
      window.addEventListener('online', onlineEventHandler);
      window.addEventListener('offline', offlineEventHandler);
    }

    return () => {
      appListener?.remove();
      window.removeEventListener('online', onlineEventHandler);
      window.removeEventListener('offline', offlineEventHandler);
    };
  }, []);

  return { online };
};
